import request from "./../utils/request";

export async function getRawMaterialList(payload) {
  return request.get("RawMaterial/List", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch ? payload.branch.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      minCost: payload.cost && payload.cost.min ? payload.price.min : null,
      maxCost: payload.cost && payload.cost.max ? payload.price.max : null,
      stockCode: payload.stockCode,
      supplierId: payload.supplier ? payload.supplier.id : null,
      supplierOwner: payload.supplierOwner,
      kdv: payload.kdv,
      variantId : payload.variant != null ? payload.variant.id : null,
    }
  });
}
export async function checkNewStockCode(newStockCode,id){
  return request.get("RawMaterial/CheckNewStockCode?stockCode=" + newStockCode + "&id=" + id);
}
export async function getRawMaterialNameList() {
  return request.get("RawMaterial/NameList");
}
export async function createNewRawMaterial(newRawMaterial){
  return request.post("RawMaterial/Create",newRawMaterial);
}
export async function getConvertedBuyPrice(toUnitId, rawMaterialId) {
  return request.get("RawMaterial/GetConvertedBuyPrice", {
    params: {
      toUnitId: toUnitId,
      rawMaterialId: rawMaterialId
    }
  })
}
export async function updateRawMaterial(rawMaterial){
  return request.post("UpdateRawMaterialQueue/Update",rawMaterial);
}
export async function deleteRawMaterial(id){
  return request.delete('RawMaterial/Delete?id='+id);
}
export async function getVariants(){
  return request.get("RawMaterial/VariantList");
}
export async function getRawMaterialListNoGroup(payload) {
  let query = serialize(payload);
  return request.get("RawMaterial/ListNoGroup?" + query);
}
function serialize(obj, prefix) {
  let str = [], p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}

